import { useContext, useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import PageContext from './PageContext';
import { HttpContext } from '../../api-services/HttpService';
import ApiRequestButton from './ApiRequestButton';
import DynamicPageInput from './DynamicPageInputCopy.jsx';
import validateInputArray from '../functions/validateInputArray';
import dynamicTransformation from '../functions/dynamicTransformation';
import dynamicValidation from '../functions/dynamicValidation';
import applyFormat from '../functions/applyFormat';
import CCOffcanvas from './CCOffcanvas.tsx';
import ButtonComponent from './ButtonComponent.jsx';
import { isAchFieldVisible, buildAchDynamicArgs, showAchInfoForMethod } from '../functions/payoutAchFields';

const EditPayoutInfoModal = () =>{
    const {
        editPayoutInfoModal, 
        setEditPayoutInfoModal,  
        editPayoutInfoRow,
        masterCompanyData,
        getRefreshData,  
        snackbarAlert, 
        payoutInfoConfig, 
        payoutInfoLists
    } = useContext(PageContext);
    // initialize http context 
    const {
        PUT, 
    } = useContext(HttpContext);
    // get global state
    const company = useSelector((state) => state.company);
    // initialize state
    const [values, setValues] = useState({}); 
    const [config, setConfig] = useState([]); 
    const [error, setError] = useState([{}]);
    // derived: whether ach info fields show for the chosen payout method
    const showAchInfo = showAchInfoForMethod(values['payoutmethodid'], payoutInfoLists['payoutmethodid']);

    const onSubmitClick = () =>{ 
        console.log('PAYOUTMETHOD: ', values['payoutmethodid']); 
        return new Promise((resolve, reject) => {
            let requestValues = [{...values}]; 
            let dynamicArgs = buildAchDynamicArgs(values['payoutmethodid']); 
            // validate array 
            let checkError = validateInputArray(
                requestValues, 
                payoutInfoConfig,
                dynamicValidation,
                {
                    ...payoutInfoLists, 
                    companyid: {
                        override: false, 
                        list: [...payoutInfoLists['companyid'], process.env.REACT_APP_MASTER_PAYOUT_INFO_PLACEHOLDER]
                    }
                }, 
                snackbarAlert,  
                error, 
                setError, 
                (row, config, args) => {
                    // run transformation on row 
                    let temp = dynamicTransformation(row, config, args); 
                    // remove index
                    delete temp['mastersetupbool']; 
                    // return transformed row 
                    return temp; 
                }, 
                dynamicArgs
            ); 
            // don't run request if error
            if (checkError) {
                reject(); 
                return; 
            }
            // add mastercompanyid to request body 
            requestValues[0]['mastercompanyid'] = masterCompanyData['mastercompanyid']; 
            requestValues[0]['companyid'] = editPayoutInfoRow['companyid']; 
            // get oldValues to attach to request 
            let temp = {...editPayoutInfoRow}
            let oldValues = applyFormat(temp, payoutInfoConfig, payoutInfoLists, null); 
            oldValues = dynamicTransformation(oldValues, payoutInfoConfig, dynamicArgs); 
            // use PUT function to make request
            let response; 
            console.log('REQUEST: ', requestValues[0]); 
            PUT('/client/payoutInfo', {
                ...requestValues[0], 
                oldValues: oldValues
            }).then(res => {  
                console.log(res); 
                response = res; 
                // hide modal 
                setEditPayoutInfoModal(editPayoutInfoModal => editPayoutInfoModal = false);
                // trigger success alert
                snackbarAlert(true, 'Successfully uploaded data.', 'success');
                // refresh company details page using function from parent
                return getRefreshData();
            }).then(res => {
                console.log(res);
                // resolve on success
                resolve(response); 
            }).catch(err => {
                console.log(err);
                // show alert on error
                snackbarAlert(true, 'Error uploading data.', 'error');
                // reject on error
                reject(err); 
            });
        }); 
    }

    
    // useEffect to run on config change 
    useEffect(() => {
        if (payoutInfoConfig){
            setConfig(config => config = payoutInfoConfig); 
        }
    }, [payoutInfoConfig]); 

    // useEffect to run on editPayoutInfoRow change
    useEffect(() => {
        if (editPayoutInfoRow) {
            console.log(editPayoutInfoRow); 
            // add ids to lookup values 
            let temp = {
                ...editPayoutInfoRow // destructure to pass by value 
            }; 
            temp = applyFormat(temp, payoutInfoConfig, payoutInfoLists, null); 
            // set state 
            setValues(values => values = temp); 
        }
    }, [editPayoutInfoRow]); 

    return(
        <> 
            <CCOffcanvas
                title={`Edit Payout Info for ${editPayoutInfoRow['companyname']}`}
                show={editPayoutInfoModal}  
                onCanvasClose={()=>setEditPayoutInfoModal(editPayoutInfoModal => editPayoutInfoModal = false)}
                bodyCssClassName="offcanvas-body bg-white p-3 pt-2"
                offCanvasClassName="offcanvas-parent-card-30"
                >   
                    <div className="d-flex flex-column h-100">
                        <div className="d-flex flex-column gap-3 flex-grow-1 overflow-scroll">
                        {config.map((el) => 
                                el['edit'] == true &&
                                isAchFieldVisible(el['columnid'], values['payoutmethodid'], showAchInfo) ? // logic for showing achinfo
                                <>
                                    <div>
                                        <DynamicPageInput 
                                            data={values} 
                                            setData={setValues} 
                                            config={el} 
                                            args={payoutInfoLists} 
                                            width={'100%'} 
                                            showError={error[0][el['columnid']]}
                                            topAlignTypography={true}
                                        />
                                    </div>
                                </>
                                : <></>
                            )}
                        </div>
                        {/* button to submit sub company */}
                        <div
                            className="d-flex justify-content-end p-3 w-100 offcanvas-footer z-2" style={{height: '65px'}}
                        >
                            <ButtonComponent tag={"Cancel"} 
                                border={'#fcd800 1px solid'} background={'#fff'} color={'#001317'} 
                                onButtonClick={()=>setEditPayoutInfoModal(editPayoutInfoModal => editPayoutInfoModal = false)}
                            />
                            <ApiRequestButton onButtonClick={onSubmitClick} />
                        </div>
                    </div>
            </CCOffcanvas>
        </>
    );
}

export default EditPayoutInfoModal;
